import { render, staticRenderFns } from "./msgOrder.vue?vue&type=template&id=6d2a5a1e&scoped=true&"
import script from "./msgOrder.vue?vue&type=script&lang=js&"
export * from "./msgOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a5a1e",
  null
  
)

export default component.exports